
import collectionCaseList from './collectionCaseList'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Vue from 'vue'
import Scroll from '../../../base/scroll/scroll'
import {eventBus} from '../../../../eventbus'
export default {
components: {
collectionCaseList, Confirm, Alert, Scroll, Popup, Flexbox, FlexboxItem, XButton
},
directives: {
TransferDom
},
data () {
return {
$vue: '',
showCollection: false,
clickedCaseId: '',
scrollbar: true,
scrollbarFade: true,
pullDownRefresh: true,
pullDownRefreshThreshold: 90,
pullDownRefreshStop: 40,
pullUpLoad: true, // 是否上拉刷新
pullUpLoadThreshold: 0,
startY: 0,
scrollToX: 0,
scrollToY: -200,
scrollToTime: 700,
scrollToEasing: 'bounce',
showInvalid: false,
showError: false,
refreshResult: '',
isHasNextPage: true,
collectionCaseId: '', // 收藏病例的caseId
reportList: [], // 诊断报告列表
scrollToEasingOptions: ['bounce', 'swipe', 'swipeBounce'],
showMoreReport: false 
}
},
methods: {
/**
* @method      getcollectionCaseId
* @author      dongkuoji
* @description 方法描述: 获取点击的收藏病例ID
* @date        2018/6/7 14:10
*/
getCollectionCaseId (prop) {
this.collectionCaseId = prop.caseId
this.checkDiagnoseReport()
},

async checkDiagnoseReport () {
let params = new URLSearchParams()
params.append('CASE_ID', this.collectionCaseId.toString())

this.$http.post(this.$vue.getData('CASE_REPORT_LIST_URL'), params).then(suc => {
if (suc.data.result === '1') {
this.reportList = suc.data.data
this.showMoreReport = true
} else {
this.showError = true
}
})
},
/**
* @method      reportDetailInfo
* @author      dongkuoji
* @description 方法描述:去报告详情页面
* @date        2018/6/7 18:01
*/
async reportDetailInfo (item) {

eventBus.$emit('showLoading', true)
let params = new URLSearchParams()
params.append('CASE_ID', this.collectionCaseId)
params.append('REPORT_CLASS', item.REPORT_CLASS)
params.append('REPORT_ID', item.ID)
let suc = await this.$http.post(this.$vue.getData('REPORT_DETAIL_URL'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data} })
} else {
this.showError = true
}
},

goDiagnosisFromCollection () {

this.$router.push({ name: 'caseShare', params: {caseid: this.collectionCaseId} })
},
/**
* @method      deleteCollectionCase
* @author      dongkuoji
* @description 方法描述:删除收藏病例
* @date        2018/5/2 14:40
*/
deleteCollectionCase () {
let params = new URLSearchParams()

params.append('CASE_ID', this.clickedCaseId.toString())

this.$http.post(this.$vue.getData('DEL_CASE_COLLECTION'), params).then(suc => {

if (suc.data.result === '1') {
this.$refs.refresh.refreshList()
}
})
},
/**
* @method      showDeleteConfirm
* @author      dongkuoji
* @description 方法描述：删除确认框
* @date        2018/5/2 14:45
*/
showDeleteConfirm (prop) {
this.clickedCaseId = prop.caseId 
this.showCollection = true 
},

getRefreshResult (prop) {
this.refreshResult = prop.result
},

getIsHasNextPage (prop) {
this.isHasNextPage = prop.result
},

onPullingDown () {
this.pullUpLoad = true

this.$refs.refresh.refreshList() 
setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 2000)
},

onPullingUp () {
if (this.isHasNextPage) {
this.$refs.refresh.loadMore()
} else {
this.pullUpLoad = false
}

setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 1500)
},
updateScrollbar (val) {
this.scrollbar = val
},
updateScrollbarFade (val) {
this.scrollbarFade = val
},
updatePullDownRefresh (val) {
this.pullDownRefresh = val
},
updatePullDownRefreshThreshold (val) {
this.pullDownRefreshThreshold = val
},
updatePullDownRefreshStop (val) {
this.pullDownRefreshStop = val
},
updatePullUpLoad (val) {
this.pullUpLoad = val
},
updatePullUpLoadThreshold (val) {
this.pullUpLoadThreshold = val
},
updatePullUpLoadMoreTxt (val) {
this.pullUpLoadMoreTxt = val
},
updatePullUpLoadNoMoreTxt (val) {
this.pullUpLoadNoMoreTxt = val
},
updateStartY (val) {
this.startY = val
},
updateScrollToX (val) {
this.scrollToX = val
},
updateScrollToY (val) {
this.scrollToY = val
},
updateScrollToTime (val) {
this.scrollToTime = val
},
updateScrollToEasing (val) {
this.scrollToEasing = val
},
rebuildScroll () {
console.log('rebuildScroll')
Vue.nextTick(() => {
this.$refs.scroll.destroy()
this.$refs.scroll.initScroll()
})
}
},
computed: {

scrollbarObj: function () {
return this.scrollbar ? {fade: this.scrollbarFade} : false
},

pullDownRefreshObj: function () {
return this.pullDownRefresh ? {
threshold: parseInt(this.pullDownRefreshThreshold),
stop: parseInt(this.pullDownRefreshStop)
} : false
},

pullUpLoadObj: function () {
return this.pullUpLoad ? {
threshold: parseInt(this.pullUpLoadThreshold),
txt: {more: this.pullUpLoadMoreTxt, noMore: this.pullUpLoadNoMoreTxt}
} : false
}
},
beforeMount () {
this.$vue = this
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/collection/collectionCaseList/collection.vue